// TextInput is Resuble component for Input fields
<template>
  <div>
    <label
      v-if="label"
      class="block text-sm font-medium text-gray-900"
      :for="id"
      >{{ label }} <span class="text-red-500" v-if="required">*</span></label
    >
    <div class="mt-1 relative">
      <input
        :id="id"
        ref="input"
        v-bind="$attrs"
        class="mt-1 block w-full border rounded-sm shadow-sm py-2 px-3 sm:text-sm focus-border-navy"
        :class="[
          {
            'border-red-400': errors.length,
            'pl-12': withIcon === true,
          },
          classes,
        ]"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @keydown="$emit('keydown', $event)"
        @blur="$emit('blur', $event)"
        @keyup="$emit('keyup', $event)"
      />
      <i
        @click="$emit('showHide')"
        v-if="type == 'password' && showIcon"
        class="fa fa-eye absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
        aria-hidden="true"
      ></i>
      <i
        @click="$emit('showHide')"
        v-if="type == 'text' && showIcon1"
        class="fa fa-eye-slash absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
        aria-hidden="true"
      ></i>
      <div v-if="errors.length" class="text-red-600 mt-1 text-sm">
        {{ errors[0] }}
      </div>

      <svg
        class="absolute text-red-600 fill-current"
        style="top: 12px; right: 12px"
        v-if="errors.length"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M11.953,2C6.465,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.493,2,11.953,2z M13,17h-2v-2h2V17z M13,13h-2V7h2V13z"
        />
      </svg>

      <div
        class="absolute left-0 top-0 bottom-0 w-10 block ml-2"
        v-if="withIcon"
      >
        <slot name="icon"></slot>
      </div>
    </div>
    <p class="mt-0 text-xs text-gray-500" id="help-description">
      {{ helptext }}
    </p>
  </div>
</template>

<script>
export default {
  name: "TextInput",

  inheritAttrs: false,

  props: {
    id: {
      type: String,
      default: "text",
    },
    type: {
      type: String,
      default: "text",
    },
    value: String,
    label: String,
    placeholder: String,
    helptext: String,
    errors: {
      type: Array,
      default: () => [],
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showIcon1: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },

  computed: {
    classes() {
      return {
        "border-2 border-barley": this.bordered === true,
        "border bg-gray-200 focus:bg-white": this.bordered === false,
      };
    },
  },
};
</script>
